var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.682a2.456 2.456 0 0 0-2.455 2.454c0 1.354 1.1 2.455 2.455 2.455 1.354 0 2.454-1.1 2.454-2.455 0-1.354-1.1-2.454-2.454-2.454Z",
    fill: "#FFC36F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.91 0 1.415 2.545 0 6.136c1.415 3.592 4.91 6.137 9 6.137 4.095 0 7.584-2.545 9-6.137C16.584 2.545 13.095 0 9 0Zm0 10.227a4.092 4.092 0 0 1-4.09-4.09A4.092 4.092 0 0 1 9 2.044a4.092 4.092 0 0 1 4.09 4.091A4.092 4.092 0 0 1 9 10.227Z",
    fill: "#FFC36F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7decd2172e9a320611428dc6e8b09a07.svg";
export { ForwardRef as ReactComponent };